<div *ngIf="isRiskProject" class="overread-settings">
  <div class="overread-title">Project Sampling</div>
  <div class="custom-description">
    Enable and customize sequential review stages ("Overreads") for this project. 
    All project tasks become eligible for review when settings are applied.
  </div>
<div class="form-factory-wrapper">
  <div class="overread-row">
    <label class="overread-label">
      Overread I
      <app-tool-tip [text]="overread1Description"></app-tool-tip>
    </label>
    <form-factory [formGroup]="riskFormGroup" [model]="overreadIProjectEnabled"></form-factory>
    <form-factory class="shift-left" [formGroup]="riskFormGroup" [model]="overreadIProjectValue"></form-factory>
  </div>

  <div class="overread-row">
    <label class="overread-label">
      Overread II
      <app-tool-tip [text]="overread2Description"></app-tool-tip>
    </label>
    <form-factory [formGroup]="riskFormGroup" [model]="overreadIIProjectEnabled"></form-factory>
    <form-factory class="shift-left" [formGroup]="riskFormGroup" [model]="overreadIIProjectValue"></form-factory>
  </div>
</div>

<div class="attribute-row" *ngIf="!isCodingReviewModeDX">
  <form-factory [formGroup]="projectSettingsFormGroup" [model]="overreadFeedbackEnabled"></form-factory>
</div>

<div class="attribute-row" *ngIf="!isCodingReviewModeDX">
  <form-factory [formGroup]="projectSettingsFormGroup" [model]="requireOverreadFeedback"></form-factory>
</div>